const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  language: state => state.app.language,
  uoloadFlag: state => state.app.uoloadFlag,
  companyconfig:state =>state.user.companyconfig,
  ts:state =>state.user.ts,
  vision:state =>state.user.vision
}
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js